import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { WebsiteService } from '../shared/website.service';
import { Router } from '@angular/router';
import { HttpClient  } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-teacher-details',
  templateUrl: './teacher-details.component.html',
  styleUrls: ['./teacher-details.component.css']
})
export class TeacherDetailsComponent implements OnInit {
  EmployeeId;
  teacherDetails: TeacherEntity;

teacherTempDetails = '{"EmployeeEducations":[{"EducationID":2,"EmployeeID":1,"ExamName":"SSC","Country":"1","EducationBoard":"11","InstituionName":"Test","PassingYear":"2022","EducationGroup":"Science","CertificateDocumentID":null,"Division":"1st","CGPA":5.00,"CreatedBy":"admin","CreatedOn":"2022-08-16T14:06:21.4","UpdatedBy":null,"UpdatedOn":null},{"EducationID":3,"EmployeeID":1,"ExamName":"HSC","Country":"1","EducationBoard":"12","InstituionName":"test","PassingYear":"2022","EducationGroup":"Science","CertificateDocumentID":null,"Division":"1st","CGPA":4.00,"CreatedBy":"admin","CreatedOn":"2022-08-16T14:06:50.683","UpdatedBy":null,"UpdatedOn":null}],"EmployeeTrainings":[{"TrainingID":1,"EmployeeID":1,"TrainingType":null,"Title":"web design ","Address":"dhaka","Country":"bangladesh","TrainingDuration":"2month","TrainingYear":"2020","InstitutionName":"SIMT","TrainingCertificateID":null,"TrainingResult":"Pass","CreatedBy":"admin","CreatedOn":"2022-08-16T14:34:04.357","UpdatedBy":null,"UpdatedOn":null},{"TrainingID":2,"EmployeeID":1,"TrainingType":null,"Title":"Network","Address":"Dhaka","Country":"Bangladesh","TrainingDuration":"4","TrainingYear":"2019","InstitutionName":"BFSL","TrainingCertificateID":null,"TrainingResult":"A+","CreatedBy":"admin","CreatedOn":"2022-08-16T14:34:47.357","UpdatedBy":null,"UpdatedOn":null}],"EmployeeExperiences":[{"ServiceHistoryID":1,"EmployeeID":1,"OrganizationName":"BFSL","Designition":"teacher","Responsibilities":"asss","StartDate":"2022-01-01T00:00:00","EndDate":"2022-08-16T00:00:00","CreatedBy":"admin","CreatedOn":"2022-08-16T14:32:12.997","UpdatedBy":null,"UpdatedOn":null},{"ServiceHistoryID":2,"EmployeeID":1,"OrganizationName":"BFSL","Designition":"training ","Responsibilities":"adaf","StartDate":"2022-06-01T00:00:00","EndDate":"2022-07-31T00:00:00","CreatedBy":"admin","CreatedOn":"2022-08-16T14:33:07.767","UpdatedBy":null,"UpdatedOn":null}],"DesignationName":"Teacher","DepartmentName":"School","DesignationShortName":"5","DepartmentCode":"1","DepartmentShortName":"1","ShiftName":"Day","VersionName":"Bangla","AttendanceTimeSettingName":null,"PhotoUrlCustom":"","EmployeeID":1,"FullName":"Md. Rubel Patwary (MAH)","FullNameBangla":"হালিম","FatherName":"test","MotherName":"test","Email":"test@gmail.com","FBID":"","Mobile":"***","EmployeeType":"Full Time","Gender":"Male","MaritaialStatus":"Single","Religion":"Islam","Nationality":"Bangledeshi","NationalIDCard":"23423423","PhotoUrl":"","EmployeeNumber":"EMP0001","JoiningDate":"2022-02-07T00:00:00","DOB":"2018-08-01T00:00:00","IsDelete":false,"IsActive":true,"IsTeacher":true,"MarraigeDate":null,"DesignationID":5,"DepartmentID":1,"ShiftID":2,"VersionID":1,"CreatedBy":"admin","CreatedOn":"2018-04-07T11:06:25.423","UpdatedBy":"admin","UpdatedOn":"2022-08-16T13:21:33.903","UserID":69,"PresentAddress":"dhaka","PermanentAddress":"dhaka","BloodGroup":"A+","EmployeeAttendanceTimeSettingsID":2,"EncryptedEmployeeID":"JhNKveESV+o=","Spouse":"asddd","PhotoUrlWithPath":"https://apiimage.astutebd.com/Uploads/demoschool1/democampus/Employees/Bangla/816202212133PMccccc.jpg"}';

  constructor(private route: ActivatedRoute,private router: Router, public websiteService: WebsiteService,public http:HttpClient) { }

  ngOnInit() {

    // Get EmployeeId from URL Param
    this.EmployeeId = this.route.snapshot.paramMap.get('EmployeeId');

    //Set Page Title
    this.websiteService.pageTitle = 'Teacher Information';    
    // var test = JSON.parse(this.teacherTempDetails);
    // this.teacherDetails =  test as TeacherEntity;
    // this.initializeTempData();
    //If EmployeeId != null than load teacher details object from API
    if(this.EmployeeId != null && this.EmployeeId != ''){
      this.loadTeacher();
    }
  }

  loadTeacher(){
    this.websiteService.getTeacherDetails(this.EmployeeId).subscribe(
      (data : any) =>{  
        this.teacherDetails = data as TeacherEntity;
        
        //If required fields are empty then load temp data in it. 
        this.initializeTempData();

        this.hideloader();
        this.hideloaderBottom();
      });

  }
  
  hideloader() {   
    // Setting display of spinner 
    // element to none 
    if(document.getElementById('loadingstatus') != null){
      document.getElementById('loadingstatus').style.display = 'none'; 
    }
  } 
  showloader() {   
    // Setting display of spinner 
    // element to none 
    if(document.getElementById('loadingstatus') != null){
      document.getElementById('loadingstatus').style.display = 'block'; 
    }
    
  } 
  hideloaderBottom() {   
    // Setting display of spinner 
    // element to none 
    if(document.getElementById('loadingstatus2') != null){
      document.getElementById('loadingstatus2').style.display = 'none'; 
    }
  } 
  showloaderBottom() {   
  // Setting display of spinner 
  // element to none 
    if(document.getElementById('loadingstatus2') != null){
      document.getElementById('loadingstatus2').style.display = 'block'; 
    }
  } 


  // Checks if an object is empty or not. Returns true if empty .
  isEmptyObject(obj) {
    if(obj === undefined || obj === '' || obj === null || Object.keys(obj).length === 0){
      return true;
    }else{
      return false;
    }
 }


 // Load Temprary Data for required fields
 initializeTempData(){
  if(this.isEmptyObject(this.teacherDetails.BioObjective)){
    this.teacherDetails.BioObjective = "First and foremost, I will love teaching and it is my life's mission. I realize by being a teacher, I am making an important contribution to the efforts of national development. I constantly endeavour to fill my mind, with great thoughts and spread the nobility in thinking and action among my students. Being a teacher I love to celebrate the success of my students all time. Because their success is my success.";
  }
  if(this.isEmptyObject(this.teacherDetails.Mobile) || this.teacherDetails.Mobile === '***'){
    this.teacherDetails.Mobile = "+8801XXXXXXX";
  }
  if(this.isEmptyObject(this.teacherDetails.Email)){
    this.teacherDetails.Email = "test@example.com";
  }
  if(this.isEmptyObject(this.teacherDetails.FBID)){
    this.teacherDetails.FBID = "https://www.facebook.com/";
  }
  if(this.isEmptyObject(this.teacherDetails.LID)){
    this.teacherDetails.LID = "https://www.linkedin.com/";
  }
  if(this.isEmptyObject(this.teacherDetails.TID)){
    this.teacherDetails.TID = "https://twitter.com/";
  }
  if(this.isEmptyObject(this.teacherDetails.IID)){
    this.teacherDetails.IID = "https://www.instagram.com/";
  }
  if(this.isEmptyObject(this.teacherDetails.WID)){
    this.teacherDetails.WID = "https://www.whatsapp.com/";
  }
 }


}


// Teacher Details Object
interface TeacherEntity{
  EmployeeEducations: [];
  EmployeeTrainings: [];
  EmployeeExperiences: [];
  DesignationName : string;
  DepartmentName: string;
  DesignationShortName: string;
  DepartmentCode: number;
  DepartmentShortName: string;
  ShiftName: string;
  VersionName: string;
  AttendanceTimeSettingName: string,
  PhotoUrlCustom: string;
  EmployeeID: number,
  FullName: string;
  FullNameBangla: string;
  FatherName: string;
  MotherName: string;
  Email: string;
  FBID: string;
  WID: string;
  LID: string;
  TID: string;
  IID: string;
  Mobile: string;
  EmployeeType: string,
  Gender: string,
  MaritaialStatus: string,
  Religion: string,
  Nationality: string,
  NationalIDCard: string;
  PhotoUrl: string,
  EmployeeNumber: string;
  JoiningDate: Date,
  DOB: Date,
  IsDelete: boolean,
  IsActive: boolean,
  IsTeacher: boolean,
  MarraigeDate: Date,
  DesignationID: number,
  DepartmentID: number,
  ShiftID: number,
  VersionID: number,
  CreatedBy: number;
  CreatedOn: Date;
  UpdatedBy: number;
  UpdatedOn: Date;
  UserID: number,
  PresentAddress: string;
  PermanentAddress: string;
  BloodGroup: string;
  EmployeeAttendanceTimeSettingsID: string,
  EncryptedEmployeeID: string;
  Spouse: string;
  PhotoUrlWithPath: string;
  BioObjective: string;
}